import { QueryListFilter } from '@feedyou-ai/feedbot-schema'

import { getPresetOptionForDateTimeFilter } from '../utils'

export function hasFilterOnlyValuesForTodayData(filter: QueryListFilter): boolean {
  return getPresetOptionForDateTimeFilter(filter) !== '0' && Object.keys(filter).length === 2
}
